import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../components/table/styled-table-row";
import { Note, NoteUpdateRequest } from "../../../service/model/note.model";
import { ReactNode, useState } from "react";
import NoteForm from "./note-form";
import { ConfirmationDialog } from "../../../components/confiramation-dialog";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { deleteNote, updateNote } from "../note.slice";
import { selectLoggedInUser } from "../../auth/auth.slice";
import TableActionButton from "../../../components/table/table-action-button";
import { NoteStatus, NoteTargetType } from "../../../shared/enums";
import { CheckCircleIcon, EditIcon, DeleteIcon } from "../../../shared/icons";
import StyledChip from "../../../components/styled-chip";

interface TableRowProps {
    readonly note: Note
}

const NoteTableRow: React.FC<TableRowProps> = ({ note }) => {
    const dispatch = useAppDispatch();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showCompletionDialog, setShowCompletionDialog] = useState(false);
    const [showNoteForm, setShowNoteForm] = useState(false);
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;

    const handleDeleteConfirm = () => {
        dispatch(deleteNote(note.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleCompletionConfirm = () => {
        dispatch(updateNote({...note, status: NoteStatus.COMPLETED }))
        setShowCompletionDialog(false)
    }

    const handleCompletionCancel = () => {
        setShowCompletionDialog(false)
    }

    const handleSubmit = (data: Note) => {
        loggedInUser && dispatch(updateNote({ ...data, id: note.id} as NoteUpdateRequest)).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowNoteForm(false);
            }
        });
    };

    const getNoteStatusChip = (status: NoteStatus): ReactNode => {
        switch (status) {
            case NoteStatus.OPEN: {
                return <StyledChip label={status} color="warning" sx={{width: '6rem'}} />
            }
            case NoteStatus.COMPLETED: {
                return <StyledChip label={status} color="success" sx={{width: '6rem'}} />
            }
            default: {
                return <></>
            }
        }
    }

    return (
        <>
            <StyledTableRow key={note.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Content</Box>{note.content}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Assigned To</Box>{note.targetName}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Assignee Type</Box>{note.targetType}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Created By</Box>{note.creatorName}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Created On</Box>{note.createdOn?.substring(0, 10)}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Due Date</Box>{note.dueDate}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Status</Box>{getNoteStatusChip(note.status as NoteStatus)}</TableCell>
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    <TableActionButton onClick={() => setShowCompletionDialog(true)} label="Mark as Completed" icon={<CheckCircleIcon />} disabled={note.status === NoteStatus.COMPLETED}/>
                    <TableActionButton onClick={() => setShowNoteForm(true)} label="Edit" icon={<EditIcon />} disabled={note.creatorId !== loggedInUser?.id}/>
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} disabled={note.creatorId !== loggedInUser?.id} />
                </TableCell>
            </StyledTableRow>
            {showNoteForm &&
                <NoteForm note={note} targetType={note.targetType as NoteTargetType} targetId={note.targetId} editable={true} onClose={() => setShowNoteForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to delete?" onConfirm={handleDeleteConfirm} onCancel={handleDeleteCancel} />
            }
            {showCompletionDialog &&
                <ConfirmationDialog show={true} message="Are you sure you want to mark this as COMPLETED?" onConfirm={handleCompletionConfirm} onCancel={handleCompletionCancel} />
            }
        </>
    );
}

export default NoteTableRow;